<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="label"
        :label="fieldLabel"
        :rules="rule"
        prepend-inner-icon="mdi-calendar-month"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-date-picker
      :value="value"
      type="month"
      locale="ru-RU"
      no-title
      @input="onPick"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'MonthSelector',

  props: {
    value: {
      type: String,
      default: null,
    },
    fieldLabel: {
      type: String,
      default: 'Месяц',
    },
  },

  data() {
    return {
      menu: false,
      rule: [() => !!this.value || 'Данное поле обязательно'],
    }
  },

  computed: {
    label() {
      if (!this.value) return ''
      const [year, month] = this.value.split('-').map(Number)
      const name = new Date(year, month - 1, 1).toLocaleString('ru-RU', { month: 'long' })
      return `${name.charAt(0).toUpperCase()}${name.slice(1)} ${year}`
    },
  },

  methods: {
    onPick(month) {
      this.$emit('input', month)
      this.menu = false
    },
  },
}
</script>
